import { ArmyBuilderConfig, DEVICE$, Product, SettingsConfig } from 'army-builder-shared';
import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

import { API_REQUEST_HEADERS } from './global/request-headers';

import globalTranslations from './global/i18n/en.json';
import fwwTranslations from './fww/i18n/en.json';
import fww2eTranslations from './fww2e/i18n/en.json';
import ffTranslations from './ff/i18n/en.json';

export const SUPPORTED_LANGUAGES = ['en'];

@Injectable({ providedIn: 'root' })
export class FalloutConfig implements ArmyBuilderConfig {
    products?: Product[];
    enableMockLogin: boolean = environment.enableMockLogin;
    appName = 'fallout';
    environment: string;

    settings = {
        ff: {
            show_force_cost_on_unit_page: { type: 'boolean', defaultValue: false }
        },
        fww: {
            show_force_cost_on_unit_page: { type: 'boolean', defaultValue: false },
            include_ai_items_by_default: { type: 'boolean', defaultValue: false },
            use_legacy_armour: { type: 'boolean', defaultValue: false }
        },
        fww2e: {
            organic_map: { type: 'boolean', defaultValue: false }
        }
    } as SettingsConfig;

    enableQRCode = false;
    enableStripePurchases = true;

    apiBaseUrl: string = environment.apiBaseUrl;
    globalRequestHeaders: any = API_REQUEST_HEADERS;
    roles = {
        admin: 'app_admin',
        user: 'app_user'
    };

    version: string = environment.appVersion;
    paths: { statusEffectIcons: string };
    partitionUnitsByFaction = false;
    supportedLanguages = SUPPORTED_LANGUAGES;
    translationGameIds = ['global', 'fww', 'ff', 'fww2e'];

    bundledTranslations = {
        global: { en: globalTranslations },
        fww: { en: fwwTranslations },
        fww2e: { en: fww2eTranslations },
        ff: { en: ffTranslations }
    };

    subscriptionEnabled = false;
    device$ = DEVICE$;

    purchaseKey = 'tRBUhJDpgnriZPmWIfDinenRNlFxZSvG';
    purchaseKeys = {
        apple: 'appl_XLlcDiXJUEEnDYBUoBqqFjtOgNe',
        google: 'goog_DWGdzLcqjhdwmmdPgrVzfxHLOWv',
        stripe: 'strp_WfwmfdSsUQMYzVGTvqNWkLWuLir'
    };

    loginPollTime = 1000 * 60 * 5; // check login/subscription status every 5 minutes (though if the server throws an unknown error, for instance if the user is offline, then the app assumes the most recent status is still valid)
    loginTimeout = 1000 * 60 * 60 * 24; // if the app can't reach the server for 24 hours, log the user out

    networkTimeout: number = 15000;
    revenueCatAppId = 'ecbf399d';
    purchaseHandlerRedirect = '/subscription';
}
